import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  FormGroup,
  Input,
  Label,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
// import { FileUploader } from "react-drag-drop-files";
import Dropzone from "react-dropzone";
import {
  uploadWorksheet,
  addWorksheetLink,
} from "../../../../actions/feedActions";
import "./addworksheet.scss";

function UploadWorksheet(props) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [fileLabel, setfileLabel] = useState("");
  const [fileSource, setfileSource] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState([]);
  const [worksheetFileName, setworksheetFileName] = useState("");
  const [fileExts, setfileExts] = useState([
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
    "gif",
    "jpg",
    "png",
    "jpeg",
  ]);
  const [fileLoader, setfileLoader] = useState(false);
  const [linkLoader, setlinkLoader] = useState(false);

  const [addLink, setaddLink] = useState("");
  const [addLinkSource, setaddLinkSource] = useState("");
  const [sourceEmail, setsourceEmail] = useState("");
  const [linkLabel, setlinkLabel] = useState("");
  const [selectionType, setselectionType] = useState(1);
  const [checkFirstOption, setcheckFirstOption] = useState("checked");
  const [agreeCheckBox, setagreeCheckBox] = useState(false);
  const [agreeCheckBox1, setagreeCheckBox1] = useState(null);
  const handleChange = (file) => {
    console.log("file data", file);
    // setFile(file);
    setworksheetFileName(file.name);
    setworksheetFileData(file);
  };

  // const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const files = worksheetFileData.map((file) => (
    <li key={file.path}>
      {file.path} - {file.type} type
    </li>
  ));
  console.log("file data", worksheetFileData);
  console.log("Worksheet Files Props", props.worksheetFiles);
  const { worksheetFiles, worksheetUrls, toggleWorksheetModal, testId } = props;
  return (
    <React.Fragment>
      <Modal isOpen={props.isOpen} centered size="md" backdrop={true}>
        <ModalHeader toggle={() => toggleWorksheetModal()}>
          Add Worksheets
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              {worksheetFiles.length ? (
                <label className="font-weight-bold">Uploaded worksheets:</label>
              ) : (
                ""
              )}
              <ul className="worksheetListing">
                {worksheetFiles &&
                  worksheetFiles.map((item, index) =>
                    item.is_s3 === 0 ? (
                      <li key={index}>
                        <a
                          target="__blank"
                          href={`https://dashboard.lincolnmethod.com/uploads/worksheets/${item.file_name}`}
                        >
                          {item.file_label}
                        </a>
                      </li>
                    ) : (
                      <li key={index}>
                        <a
                          target="__blank"
                          href={`https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/${item.file_name}`}
                        >
                          {item.file_label}
                        </a>
                      </li>
                    )
                  )}
              </ul>
              {worksheetUrls.length ? (
                <label className="font-weight-bold">URLS for worksheet:</label>
              ) : (
                ""
              )}
              <ul className="worksheetListing">
                {worksheetUrls &&
                  worksheetUrls.map((item, index) => (
                    <li key={index}>
                      <a target="__blank" href={item.link}>
                        {item.link.substring(0, 50)}
                      </a>
                    </li>
                  ))}
              </ul>
              <div id="worksheetAccordion" class="">
                <div
                  className="accordionTitle"
                  data-toggle="collapse"
                  data-target={`#Onework1`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Upload a new worksheet <i className="fas fa-chevron-down" />
                </div>

                <div
                  id={`Onework1`}
                  class="collapse accordionData"
                  aria-labelledby="headingOne"
                  data-parent="#worksheetAccordion"
                >
                  <Row>
                    <Col sm="12">
                      <FormGroup>
                        <label className="font-weight-bold mt-2">
                          Give this worksheet a name
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={fileLabel}
                          placeholder=""
                          onChange={(event) => {
                            setfileLabel(event.target.value);
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm="12">
                      <FormGroup>
                        <Dropzone
                          onDrop={(acceptedFiles) =>
                            setworksheetFileData(acceptedFiles)
                          }
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ className: "dropzone" })}>
                              <input {...getInputProps()} />
                              <p>
                                Drag 'n' drop file here, or click to select
                                files
                              </p>
                            </div>
                          )}
                        </Dropzone>

                        {worksheetFileData && worksheetFileData.length ? (
                          <div className="mt-2">
                            <label className="font-weight-bold">File:</label>
                            {files}
                          </div>
                        ) : null}

                        <div class="form-check form-check-inline mt-5">
                          <input
                            className="form-check-input"
                            type="radio"
                            onClick={(e) => setagreeCheckBox1("1")}
                            checked={agreeCheckBox1 == "1"}
                          />
                          <label
                            class="form-check-label"
                            style={{ fontSize: "15px" }}
                          >
                            This content was created by someone else
                          </label>
                          <input
                            className="form-check-input"
                            type="radio"
                            checked={agreeCheckBox1 == "0"}
                            onClick={(e) => setagreeCheckBox1("0")}
                          />
                          <label
                            class="form-check-label"
                            style={{ fontSize: "15px" }}
                          >
                            This content was created by me
                          </label>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <button
                        className="btn btn-success btn-block"
                        disabled={agreeCheckBox1 ? false : true}
                        onClick={() => {
                          if (worksheetFileData == "") {
                            alert("Please add the file.");
                            return false;
                          } else {
                            var userData = JSON.parse(
                              window.localStorage.loginData
                            ).user;
                            var userId = userData.id;
                            setfileLoader(true);
                            uploadWorksheet(
                              testId,
                              userId,
                              fileLabel,
                              fileSource,
                              worksheetFileData[0],
                              agreeCheckBox1,
                              0
                            )
                              .then((fileRes) => {
                                setfileLoader(false);
                                if (fileRes.data.status) {
                                  setfileLoader(false);
                                  setworksheetFileData([]);
                                  setfileLabel("");
                                  window.location.reload();
                                }
                              })
                              .catch((err) => {
                                console.log("This is the err:", err);
                              });
                          }
                        }}
                      >
                        Submit{" "}
                        {fileLoader && (
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      </button>
                    </Col>
                  </Row>
                </div>
                <div className="text-center mt-3">
                  <label style={{ fontSize: 15, color: "#c1c1c1" }}>OR</label>
                </div>
                <div
                  className="accordionTitle"
                  data-toggle="collapse"
                  data-target={`#Onework2`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Add a web link for a new worksheet{" "}
                  <i className="fas fa-chevron-down" />
                </div>

                <div
                  id={`Onework2`}
                  class="collapse accordionData"
                  aria-labelledby="headingOne"
                  data-parent="#worksheetAccordion"
                >
                  <Row>
                    <Col sm="12">
                      <FormGroup>
                        <label className="font-weight-bold mt-2">
                          Give this worksheet a name
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={linkLabel}
                          placeholder=""
                          onChange={(event) => {
                            setlinkLabel(event.target.value);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <label className="font-weight-bold mt-2">
                          Add web link here
                        </label>
                        <Input
                          className="form-control form-control-sm"
                          type="text"
                          value={addLink}
                          placeholder=""
                          onChange={(event) => {
                            setaddLink(event.target.value);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <div class="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            onClick={(e) => setagreeCheckBox(e.target.checked)}
                            value={agreeCheckBox}
                          />
                          <label
                            class="form-check-label"
                            style={{ fontSize: "15px" }}
                          >
                            I certify that this is a free resource (no
                            copyright infringement)
                          </label>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <button
                        className="btn btn-success btn-block"
                        disabled={agreeCheckBox ? false : true}
                        style={{ marginTop: "9%", width: "100%" }}
                        onClick={() => {
                          if (addLink == "") {
                            alert("link is required.");
                            return false;
                          } else {
                            console.log("everything working fine.");
                            var userData = JSON.parse(
                              window.localStorage.loginData
                            ).user;
                            var userId = userData.id;
                            setlinkLoader(true);
                            addWorksheetLink(
                              testId,
                              userId,
                              addLink,
                              addLinkSource,
                              sourceEmail,
                              linkLabel
                            )
                              .then((linkRes) => {
                                if (linkRes.data.status) {
                                  setlinkLoader(false);
                                  setaddLink("");
                                  setlinkLabel("");
                                  window.location.reload();
                                }
                              })
                              .catch((err) => {
                                console.log("This is the err:", err);
                              });
                          }
                        }}
                      >
                        {linkLoader == true ? (
                          <Spinner size="sm" style={{ marginRight: "5px" }} />
                        ) : null}
                        Submit
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {/* <Button color="secondary" onClick={toggle}>Cancel</Button> */}
        </ModalFooter>
      </Modal>
    </React.Fragment>

    // </Container>
  );
}
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, {})(UploadWorksheet);
